import { styled } from '@mui/material/styles';
import { Box, Icon } from '@mui/material';

export const Container = styled(Box)({
  position: 'absolute',
  right: 10,
  top: 10,
  zIndex: 10,
});

export const PrintIconContainer = styled('div')({
  position: 'relative',
});

export const CheckIcon = styled(Icon)(({ theme }) => ({
  position: 'absolute',
  right: -11,
  top: 10,
  fontSize: 20,
  color: theme.palette.success.main,
}));
